module.exports = __webpack_public_path__ + "img/sidebar-close@2x.99f7cc02.png";